import { Pipe, PipeTransform } from '@angular/core';
import { SmsStatus } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'smsStatusDisplay',
})
export class SmsStatusDisplayPipe implements PipeTransform {
  transform(value: SmsStatus): string {
    return smsStatusDisplayTransform(value);
  }
}

export function smsStatusDisplayTransform(value: SmsStatus) {
  return CoreNiceLabelUtils.smsStatus(value);
}
